export default {
  // variable que activa o desactiva la nueva epg.
  enable_epg_persistance: true,
  //Activa la paginacion de epgPersistance
  enable_epg_pagination: false,
  // activa el resumen_persistance
  enable_resume_persistance: true,
  // Activa la sincronizacion entre la grilla de eventos y la grilla de canales.
  enable_epg_syc: true,
  // external URL to check network status when ajax
  check_online_url: `check-online`,
  // Interval to check network status, in seconds
  interval_time_check_: 15,
  //Ribbons time to expire, in seconds (same TTL for ribbons cards, when level cache expires then reload cards)
  duration_of_ribbons_in_cache: 3600, // 1 hora
  // Enable or not debugger use
  debugger_enabled: false,

  //time to send lineal channel, milisegundos
  interval_lineal_chanel: 3600000, // 1 hora

  // credits time default, in seconds
  rolling_credits_time: -30,

  // Event that is fired when VOD reached credits time (only full player)
  end_vod_fire_event: 'onEndVOD',

  //path de suscribirte
  path_suscription: 'planSelector',

  //path iptelmex
  path_iptelmex: 'iptelmex',

  //Path Register Form

  path_register: 'register',

  // Evento que envía ps4 cuando AAF entra en segundo plano o se reactiva
  playstation_app_status_change: 'playstation_app_status_change',

  // Event that is fired to networkDisconnection
  event_change_network_status: 'current-network-status',

  // Event that is fired to handle epg's visibility
  show_epg: 'epgVisibility',

  // Event that is fired to handle blue button action in Persistent EPG
  blue_button_epg_Persistance: 'epgPersistanceBlueButton',

  //Event fires to show 'cintillo'
  show_head_band: 'showBlueHeadBand',


  // Position of EndPlayer Component
  end_player_position_top: 285,
  end_player_position_left: 57,
  end_player_position_height: 150,
  end_player_position_width: 265,

  //Event fired when stop a play media to update progress view of the video
  update_progress: 'updateProgress',

  live_fullplayer_position_top: 106,
  live_fullplayer_position_left: 950,
  live_fullplayer_position_height: 170,
  live_fullplayer_position_width: 302,

  full_player_position_top:0,
  full_player_position_left:0,
  full_player_position_height:'720px',
  full_player_position_width:'1280px',

  prepend_multiple: '_ma',

  /**
   * ****Por el momento sólo usar para debug
   * Importante: TODO falta hacer el clear/reset del cache cuando el usuario haga login o haga logout, según sea el caso
   * En estos momentos el caché guardará todos los ribbons, tanto del logueado como del anónimo
   * Se usa en los ribbons de level y leveluser)
   */
  use_ribbons_cache: false,

  /**
   * * ****Por el momento sólo usar para debug
   * Aplica sobre level y leveluser y es independiente del setting de arriba use_ribbons_cache
   * Poner null o false si no se usa
   * Poner un número si existe el máximo
   * use_max_ribbons = número máximo de ribbons para mostrar por nodo
   * use_max_ribbons_items = número máximo items/cards por ribbons para mostrar
   */
  use_max_ribbons: false,
  use_max_ribbons_items: false,
  check_app_version: true,

  /*
   ** EPG cache Toggle y configuracion
   */

  epg_cache_enabled: false,

  not_use_pip_platform: ["arris"],

  timeshift_by_event_enabled: true,

  work_with_trickmode: ['hls_kr'],
  /**
   * tenant code param, to send to music CM-MW
   */
  tenant_code: 'aaf',
  /**
   * Use CM-MW to get music token
   */
  music_use_login_dynamic_cm_middleware: true,

  /**
   * Sólo para usar Dexie en local, emulando con android en el browser
   */
  use_dexie: false,

  /**
   *Evento Button filter
   */
  button_filter: 'button_filter',

  /**
   * Sólo para debug, dejar en false para prod
   */
  player_controls_enable_screen_seconds: false,

  //fake_url_mockoon: 'http://localhost:3001/pau'
  fake_url_mockoon: null,
  // Settings for Versioned ebdpoints task
  use_mock_endpoint: false,
  mock:{
    server:'virtserver.swaggerhub.com',
  },

  //Settings for Google Analitycs

  ga4: {
    eneabled: true,
    debugger_enabled : false
  }
};

/*
 Player states:
 0 connect
 1 stop
 2 playing
 3 paused
 4 skip
 5 speed
 6 buffering
 */
export const PONCONNECT = 0;
export const PONSTOP = 1;
export const PONPLAY = 2;
export const PONPAUSE = 3;
export const PONSKIP = 4;
export const PONSPEED = 5;
export const PONBUFFER = 6;
export const IPTV = 'iptv';
export const IPTV_ALTERNO = 'ptv';
export const OTT = 'ott';



// WEBPACK FOOTER //
// ./src/devices/all/settings.js